import { Divider, Form, Input, Switch } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import Box from '../../../components/boxes/Box';
import LoadingSpinner from '../../../components/buttons/LoadingSpinner';
import Typography from '../../../components/typography/Typography';
import {
  AssetPackInterface,
  GroupedPacks,
  PackTemplate,
} from '../../../interfaces/AssetPacks';
import ListComponent from '../../../utils/ListComponent';
import AssetPackDetail from '../../products/AssetPackDetail';

interface props {
  packs: GroupedPacks | undefined;
  onclick: (selectedItems: AssetPackInterface[], packType: string) => void;
  unassignedAssets?: any | undefined;
  initialUnassignedAssets?: AssetPackInterface[] | undefined;
  initialSelection?: AssetPackInterface[];
}

const PACK_TYPE_ORDER = ['PRODUCT', 'LICENSE', 'ACCESOIRIES'];

const SelectAssetPacksForm: FC<props> = ({
  onclick,
  initialSelection = [],
  initialUnassignedAssets = [],
  packs,
  unassignedAssets = [],
}) => {
  const [selectedPacks, setSelectedPacks] =
    useState<AssetPackInterface[]>(initialSelection);
  const [selectedAssets, setSelectedAssets] = useState<AssetPackInterface[]>(
    initialUnassignedAssets
  );

  console.log(unassignedAssets);

  useEffect(() => {
    setSelectedPacks(initialSelection);
  }, [initialSelection, packs]);

  useEffect(() => {
    setSelectedAssets(initialUnassignedAssets);
  }, [initialUnassignedAssets]);

  const getPackTypeById = (packId: string): string | undefined => {
    if (!packs) return undefined;
    for (const [type, packList] of Object.entries(packs)) {
      if (
        packList.some((pack: PackTemplate) => pack.PackTemplateID === packId)
      ) {
        return type;
      }
    }
    return undefined;
  };

  const selectItem = (itemId: string, itemName: string, itemType: string) => {
    const selectedItem: AssetPackInterface = { id: itemId, name: itemName };

    if (itemType === 'old') {
      setSelectedAssets((prevSelectedAssets) => {
        const isSelected = prevSelectedAssets.some(
          (item) => item.id === itemId
        );

        const newSelectedAssets = isSelected
          ? prevSelectedAssets.filter((item) => item.id !== itemId) // unselect
          : [...prevSelectedAssets, selectedItem]; // select multiple allowed

        onclick(newSelectedAssets, 'old');
        return newSelectedAssets;
      });
    } else {
      setSelectedPacks((prevSelectedPacks) => {
        const isSelected = prevSelectedPacks.some((item) => item.id === itemId);

        const newSelectedPacks = isSelected
          ? prevSelectedPacks.filter((item) => item.id !== itemId)
          : [...prevSelectedPacks, selectedItem]; // multi-select allowed

        onclick(newSelectedPacks, 'new');
        return newSelectedPacks;
      });
    }
  };

  const getSortIndex = (packType: string) => {
    const index = PACK_TYPE_ORDER.indexOf(packType);
    return index === -1 ? PACK_TYPE_ORDER.length : index;
  };

  return (
    <>
      <div>
        <Typography tag="h2" type="subtitle" addClass={'mb-2'}>
          Packs
        </Typography>
        <Typography tag="p" type="small">
          Vooraf samengestelde sets van hardware en licenties
        </Typography>
      </div>
      <Typography tag="h2" type="labelSemiBold" addClass={'my-4'}>
        Beschikbare packs
      </Typography>
      {!packs ? (
        <LoadingSpinner />
      ) : (
        <div>
          {Object.entries(packs)
            .sort(
              ([typeA], [typeB]) => getSortIndex(typeA) - getSortIndex(typeB)
            )
            .map(([packType, packList]) => (
              <div key={packType} className="mb-8">
                <Box size="smallest" type="clean" gridSize="grid-3">
                  <ListComponent
                    data={packList}
                    renderItem={(item: PackTemplate) => (
                      <div
                        key={item.PackTemplateID}
                        className="cursor-pointer"
                        onClick={() =>
                          selectItem(
                            item.PackTemplateID,
                            item.PackName,
                            item.PackType
                          )
                        }
                      >
                        <AssetPackDetail
                          pack={item}
                          selected={selectedPacks.some(
                            (selected) => selected.id === item.PackTemplateID
                          )}
                        />
                      </div>
                    )}
                  />
                </Box>
              </div>
            ))}
        </div>
      )}

      {unassignedAssets ? (
        <div className="mt-4">
          <Divider dashed className="bg-blue-100" />

          <Typography tag="h2" type="subtitle" addClass={'mb-2'}>
            Niet toegewezen hardware:
          </Typography>
          <Typography tag="p" type="small">
            Deze hardware is niet toegekend
          </Typography>
          <Typography tag="p" type="small" addClass="text-red-400">
            Hardware is niet zeker klaar
          </Typography>

          <div className="grid grid-cols-3 gap-2 mt-4">
            <ListComponent
              data={unassignedAssets}
              renderItem={(item: any) => (
                <div
                  key={item.PackTemplateID}
                  className="cursor-pointer"
                  onClick={() =>
                    selectItem(
                      item.ordPro_id.toString(),
                      item.ordPro_naam,
                      'old'
                    )
                  }
                >
                  <AssetPackDetail
                    pack={{
                      PackName: item.ordPro_naam,
                      PackType: item.ordPro_categorie,
                      PackDetails: { products: [] },
                    }}
                    selected={selectedAssets.some(
                      (selected) => selected.id === item.ordPro_id.toString()
                    )}
                  />
                </div>
              )}
            />
          </div>

          {selectedAssets.length > 0 ? (
            <>
              <div className="flex items-center mt-4">
                <div className="flex items-center space-x-3">
                  <Form.Item
                    name="cleanInstall"
                    valuePropName="checked"
                    className="!mb-0 flex items-center"
                  >
                    <Switch className="antd-switch-fix" />
                  </Form.Item>
                  <Typography tag="label" type="label" addClass="leading-none">
                    Hardware opnieuw installeren?
                  </Typography>
                </div>
              </div>
              <Typography tag="p" type="small">
                Hardware opnieuw installeren info
              </Typography>
            </>
          ) : (
            ''
          )}
        </div>
      ) : (
        ''
      )}
      <Divider dashed className="bg-blue-100" />
      <div className="mt-4">
        <Typography tag="h2" type="subtitle" addClass={'mb-2'}>
          Niet gevonden wat je zocht
        </Typography>
        <Typography tag="p" type="label">
          Het gebeurt dat er iets specifiek nodig is
        </Typography>
      </div>
      <div className="flex items-center mt-4">
        <div className="flex items-center space-x-3">
          <Form.Item
            name="contact"
            valuePropName="checked"
            className="!mb-0 flex items-center"
          >
            <Switch className="antd-switch-fix" />
          </Form.Item>
          <Typography tag="label" type="label" addClass="leading-none">
            Contacteer mij
          </Typography>
        </div>
      </div>
      <Divider dashed className="bg-blue-100" />
      <div className="col-span-3">
        <Form.Item name="opmerking" label="Opmerking(en)">
          <Input />
        </Form.Item>
      </div>
    </>
  );
};

export default SelectAssetPacksForm;
